$(document).ready(function() {
  
// init Isotope

// Activitats & Artists Filters
var $grid = $('.grid-activitats,.grid-artists').isotope({
  itemSelector: '.grid-item',
});

// Artists - Single  blocks layout
 if (Foundation.MediaQuery.is('medium')) {
  $('.grid-blocks').isotope({
    layoutMode: 'packery',
    itemSelector: '.grid-item',
  });
}

// var $grid = $('.grid').isotope({
//   layoutMode: 'packery',
//   itemSelector: '.grid-item'
// });



// store filter for each group
var filters = {};

$('.filters').on( 'click', '.button', function( event ) {
  var $button = $( event.currentTarget );
  // get group key
  var $buttonGroup = $button.parents('.button-group');
  var filterGroup = $buttonGroup.attr('data-filter-group');
  // set filter for group
  filters[ filterGroup ] = $button.attr('data-filter');
  // combine filters
  var filterValue = concatValues( filters );
  // set filter for Isotope
  $grid.isotope({ filter: filterValue });
});

// change is-checked class on buttons
$('.button-group').each( function( i, buttonGroup ) {
  var $buttonGroup = $( buttonGroup );
  $buttonGroup.on( 'click', 'button', function( event ) {
    $buttonGroup.find('.is-checked').removeClass('is-checked');
    var $button = $( event.currentTarget );
    $button.addClass('is-checked');
  });
});
  
// flatten object by concatting values
function concatValues( obj ) {
  var value = '';
  for ( var prop in obj ) {
    value += obj[ prop ];
  }
  return value;
}


  // reset ALL filters
  var $anyButtons = $('.filters').find('button[data-filter=""]');
  var $buttons = $('.filters button');
  // var $button_reset = $('.filters.button.button-reset');
  var $button_reset = $('.filters').find('button[data-filter="*"]');

  $('.reset-all').on( 'click', function() {
    // reset filters
    filters = {};
    $grid.isotope({ filter: '*' });
    // reset buttons
    $buttons.removeClass('is-checked');
    $anyButtons.addClass('is-checked');
    $button_reset.addClass('is-checked');
  });





// Search

// Search - Open search field
$('#search-filter-btn').on('click', function() {
  $("#search-filter-field").toggleClass("hidden");
});






});